const isYouTubeURL = (url) => {
	if (!url) {
		return false;
	}
	return url.startsWith("https://youtu") || url.startsWith("https://www.youtu");
}

export default isYouTubeURL;